// Utility functions for measuring page performance

/**
 * @internal
 */
export function now(): number {
    return (window.performance && performance.now) ? Math.round(performance.now()) : Date.now();
}

/**
 * @internal
 */
export function mark(name: string): void {
    if (window.performance && performance.mark) {
        performance.mark(name);
    }
}
